import PropTypes from "prop-types";
import React from "react";
import { Col, Row } from "react-bootstrap";
import * as Application from "redux-store/applications";
import { AdPlatformSyncedAlert } from "ui/alert/ad-platform-synced-alert";
import { List } from "ui/list";
import { Notification } from "ui/notification";
import { AppParameterForm } from "ui/parameter-form/app-param-form";
import { Box } from "view/layout/box";

import { PRIORITY } from "./utils";

class AppParameterFormLayout extends React.PureComponent {
  static get propTypes() {
    return {
      ...AppParameterForm.propTypes,
      app: PropTypes.object.isRequired,
      onRemove: PropTypes.func.isRequired,
      readonly: PropTypes.bool.isRequired,
      schemas: PropTypes.arrayOf(PropTypes.object),
    };
  }

  _collectErrors(app, formErrors) {
    const appId = String(app.id);

    return Object.entries(formErrors || {})
      .filter(([path, _value]) => path === appId)
      .reduce((acc, [_path, value]) => value, []);
  }

  render() {
    const {
      app,
      formErrors,
      onRemove,
      readonly,
      priority,
      schemas,
      systemManagedParams,
      version,
      ...rest
    } = this.props;

    if (!app) {
      return null;
    }

    const errors = this._collectErrors(app, formErrors);
    const errList = errors.length ? (
      <List className="list-compact" items={errors} />
    ) : null;
    const objectName = priority === PRIORITY.DEVICE ? "device" : "network";
    const systemManaged = Boolean(systemManagedParams);
    const shouldDisplayAlert = systemManaged && Application.systemManaged(app);

    return (
      <Box
        className="app-param-form-box"
        key={app.id}
        title={app.display_name}
        subtitle={`Version: ${version.version}`}
      >
        <button
          className="btn btn-circle btn-up-right"
          disabled={readonly}
          onClick={() => {
            onRemove(app.id);
          }}
        >
          <i className="fa fa-times" />
        </button>
        <Row>
          <Col xs={12}>
            <Notification error={errList} />
            {shouldDisplayAlert && (
              <AdPlatformSyncedAlert objectName={objectName} />
            )}
            <AppParameterForm
              {...rest}
              app={app}
              formErrors={formErrors}
              readonly={readonly}
              priority={priority}
              schemas={schemas}
              systemManagedParams={systemManagedParams}
            />
          </Col>
        </Row>
      </Box>
    );
  }
}

export { AppParameterFormLayout };
